module.exports = __webpack_public_path__ + "static/media/dramaImg9.5c03bc80.jpg";